import LEmpty from './src/main'

LEmpty.install = function(Vue) {
  Vue.component(LEmpty.name, LEmpty)
}

export default LEmpty
